import { el } from "../lib/dom";
import { sectionCover } from "../lib/sectionCover";
import { faq } from "../content/site";
import { photos } from "../content/photos.generated";

export function renderFaq(root: HTMLElement) {
  const page = el("section", { class: "page", id: "faq" });

  page.appendChild(
    sectionCover({
      title: "Vrae en Antwoorde",
      photo: photos.gallery[21] ?? photos.gallery[0] ?? null,  // IMG_4806 (same as before, reindexed)
      bgPosition: "center 25%",                                // shifted up
    }),
  );

  const content = el("div", { class: "page__content" });

  const wrap = el("div", { class: "faq" });
  for (const item of faq) {
    const node = el("div", { class: "faq__item", "data-open": "false" });
    const btn = el("button", { class: "faq__q", type: "button" }, item.q, el("span", {}, "+"));
    const ans = el("div", { class: "faq__a" }, el("p", {}, item.a));
    btn.addEventListener("click", () => {
      const open = node.dataset.open === "true";
      node.dataset.open = open ? "false" : "true";
      btn.querySelector("span")!.textContent = open ? "+" : "–";
    });
    node.appendChild(btn);
    node.appendChild(ans);
    wrap.appendChild(node);
  }
  content.appendChild(wrap);
  page.appendChild(content);
  root.appendChild(page);
}
